import * as R from 'ramda';
import { select, put, takeLatest } from 'redux-saga/effects';
import { parseDataRange } from '@sis-cc/dotstatsuite-sdmxjs';
import { rules } from '@sis-cc/dotstatsuite-components';
import { getFrequency, getHiddenValuesAnnotation } from '../../selectors/sdmx';
import { HANDLE_DATA } from '../../ducks/sdmx';
import {
  setPending,
  pushLog,
  LOG_ERROR_SDMX_DATA,
  flushLog,
  UPDATE_SAGA_KEY,
} from '../../ducks/app';
import { locales } from '../../lib/settings';
import { CHANGE_LAYOUT } from '../../ducks/vis';
import { PARSE_MICRODATA, HANDLE_MICRODATA } from '../../ducks/microdata';
import { getDataflow, getLocale } from '../../selectors/router';
import { getSagaKey } from '../../selectors/app';
import { MICRODATA } from '../../utils/constants';

function* parseData({ data, datatype = '', queryKey }) {
  const sagaId = R.isEmpty(datatype)
    ? 'parseData'
    : `parseM${R.tail(datatype)}`;
  const key = yield select(getSagaKey(sagaId));
  if (key === queryKey && !R.isNil(queryKey)) return;

  yield put({ type: UPDATE_SAGA_KEY, sagaKey: queryKey, sagaId });

  // avoid using dynamic types to detect missing things during dev
  // ie `FLUSH_${datatype}` instead of using FLUSH_DATA or FLUSH_MICRODATA or else
  let HANDLE = HANDLE_DATA;
  if (R.equals(datatype, MICRODATA)) HANDLE = HANDLE_MICRODATA;

  const locale = yield select(getLocale);
  const freq = yield select(getFrequency);
  const dataflow = yield select(getDataflow);
  const hiddenIds = yield select(getHiddenValuesAnnotation);
  let options = {
    frequency: freq,
    locale,
    dataflowId: dataflow.dataflowId,
    hiddenIds,
    timeFormat: R.path([locale, 'timeFormat'], locales),
  };

  try {
    // isParsing start
    yield put(setPending('parsingData', true));
    yield put(flushLog(LOG_ERROR_SDMX_DATA));
    yield put({
      type: HANDLE,
      data: R.prop('data', rules.v8Transformer(data.data, options)),
      range: parseDataRange(data),
    });

    /*
     * triggers historyMiddleware to update the url with existing layout and dimensions from data
     * complete layout in location state is correct
     * partial (compact) layout in location search can't be correct without dimensions from data request
     * the following empty action is used to update location search and have a synced url
     * note 1: if pathname is not provided, existing is kept
     * note 2: if payload is empty, not override will occur (do not mix with no payload which is a reset)
     */
    yield put({ type: CHANGE_LAYOUT, replaceHistory: { payload: {} } });
    yield put(setPending('parsingData', false));
  } catch (error) {
    yield put(setPending('parsingData', false));
    yield put(pushLog({ type: LOG_ERROR_SDMX_DATA, log: error }));
  }
}

export function* watchParseData() {
  yield takeLatest(PARSE_MICRODATA, parseData);
}
